<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="logo">
      <img src="@/assets/img/mayologo.png" />
    </div>
    <div class="menu">
      <div class="left-bg">
        <div class="left">
          <h1>Our Facility</h1>
          <div class="line"></div>
          <div class="menu-item">
            <p
              id="overview"
              @click="toggleActive"
              :class="{ active: current === 'overview' }"
            >
              Equipment
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p
              id="equipment"
              @click="toggleActive"
              :class="{ active: current === 'equipment' }"
            >
              Map
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p
              id="process"
              @click="toggleActive"
              :class="{ active: current === 'process' }"
            >
              Staff
            </p>
            <img src="@/assets/img/go.png" />
          </div>
        </div>
      </div>

      <div class="right">
        <transition>
          <div class="overview" v-if="current === 'overview'">
            <h3>Equipment</h3>
            <div class="inner-nav">
              <div class="card" @click="popup = 10">
                <img src="@/assets/img/EOSM290.png" />
                <p>EOS M290 TITANIUM</p>
              </div>

              <div class="card" @click="popup = 11">
                <img src="@/assets/img/Markforged-Mark-Two.png" />
                <p>MARKFORGED MARK TWO</p>
              </div>

              <div class="card" @click="popup = 12">
                <img src="@/assets/img/Stratasys-F370.png" />
                <p>STRATASYS F370</p>
              </div>

              <div class="card" @click="popup = 13">
                <img src="@/assets/img/Hp-jet-fusion-580.png" />
                <p>HP JET FUSION 580</p>
              </div>
              <div class="card" @click="popup = 14">
                <img src="@/assets/img/Formlabs-form3.png" />
                <p>FORMLABS FORM 3</p>
              </div>
              <div class="card" @click="popup = 15">
                <img src="@/assets/img/Stratasys-fortus-400mc.png" />
                <p>STRATASYS FORTUS 400MC</p>
              </div>
            </div>
          </div>
        </transition>

        <div v-if="popup == 10" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/3939784_0008-min.jpg" />
              <div class="column">
                <h3>EOS M290 TITANIUM PRINTER</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> EOS</li>
                <li><b>Model:</b> M290 Titanium Printer</li>
                <li><b>Technology:</b> DMLS - Direct Metal Laser Sintering</li>
                <li><b>Material:</b> Titanium Alloy Ti6AI4v ELI</li>
                <li>
                  <b>Uses:</b> Production Parts, medical devices, human
                  implantables
                </li>
                <li>
                  <b>Advantages:</b> Fast, flexible, and cost - effective metal
                  parts directly from CAD data
                </li>
                <li><b>Build Volume:</b> 9.85 x 9.85 x 12.8 in</li>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popup == 11" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/markforged.png" />
              <div class="column">
                <h3>MARKFORGED MARK TWO</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> Markforged</li>
                <li><b>Model:</b> Mark Two</li>
                <li><b>Technology:</b> FFF - Fused Filament Fabrication</li>
                <li>
                  <b>Material:</b> Nylon – carbon fiber, Kevlar, or fiberglass
                  reinforcement
                </li>
                <li>
                  <b>Uses:</b> Models, prototypes, tooling, and end-use parts
                </li>
                <li>
                  <b>Advantages:</b> Production grade parts. High strength.
                  Fiber reinforced. Ready for use right off printer.
                </li>
                <li><b>Build Volume:</b> 12.6 x 5.2 x 6 in</li>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popup == 12" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/stratasys.png" />
              <div class="column">
                <h3>Stratasys f370 printer</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> Stratasys</li>
                <li><b>Model:</b> F370</li>
                <li><b>Technology:</b> FDM – Fused Deposition Modeling</li>
                <li><b>Material:</b> Production-grade Thermoplastics</li>
                <li>
                  <b>Uses:</b> Models, prototypes, tooling, and end-use parts
                </li>
                <li>
                  <b>Advantages:</b> Production grade parts. Wide variety of
                  thermoplastics. High strength. Auto-calibration; fast, easy
                  material swaps; soluble support material.
                </li>
                <li><b>Build Volume:</b> 14 x 10 x 14 in</li>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popup == 13" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/fusion580.png" />
              <div class="column">
                <h3>HP Jet Fusion 580 Color Printer</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> HP</li>
                <li><b>Model:</b> Jet Fusion 580</li>
                <li><b>Technology:</b> MJF - Multi-Jet Fusion</li>
                <li><b>Material:</b> Nylon</li>
                <li><b>Uses:</b> Concept models, prototypes, and tooling</li>
                <li>
                  <b>Advantages:</b> Uses inkjet color printing technology.
                  Engineering-grade thermoplastic. Automated material mixing,
                  loading, extraction, and reclamation.
                </li>
                <li><b>Build Volume:</b> 13.1 x 7.5 x 9.8 in</li>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popup == 14" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/formlabs.png" />
              <div class="column">
                <h3>Formlabs Form 3 Printer</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> Formlabs</li>
                <li><b>Model:</b> Form 3</li>
                <li><b>Technology:</b> LFS - Low Force Stereolithography</li>
                <li><b>Material:</b> Photopolymer Engineering Resins</li>
                <li>
                  <b>Uses:</b> Models, prototypes, tooling, and end-use parts
                </li>
                <li>
                  <b>Advantages:</b> Low Cost. High Strength. High Precision.
                  Surface finish. Variety of martials. Fast, easy material
                  swaps.
                </li>
                <li><b>Build Volume:</b> 5.7 x 5.7 x 7.3 in</li>
              </div>
            </div>
          </div>
        </div>
        <div v-if="popup == 15" class="popup">
          <div class="offclick" @click="popup = false"></div>
          <div class="room">
            <div class="info row">
              <img src="@/assets/img/fortus.png" />
              <div class="column">
                <h3>Stratasys Fortus 400mc Printer</h3>
                <div class="line2"></div>
                <li><b>Manufacturer:</b> Stratasys</li>
                <li><b>Model:</b> Fortus 400mc</li>
                <li><b>Technology:</b> FDM – Fused Deposition Modeling</li>
                <li><b>Material:</b> Production-grade thermoplastics</li>
                <li>
                  <b>Uses:</b> Models, prototypes, tooling, and end-use parts
                </li>
                <li>
                  <b>Advantages:</b> Production grade parts. Wide variety of
                  thermoplastics. High strength.
                </li>
                <li><b>Build Volume:</b> 14 x 10 x 10 in</li>
              </div>
            </div>
          </div>
        </div>
        <transition>
          <div class="equipment" v-if="current === 'equipment'">
            <!-- <h3>Our State of the Art Equipment</h3> -->
            <svg class="facility" viewBox="0 0 926.25 557.99">
              <g class="blocks">
                <path
                  class="block5"
                  @click="popup = 5"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 1H182V132.844V140V144H177V140H138V144H0V140V135V1Z"
                  fill="#1F479A"
                />
                <path
                  class="block3"
                  @click="popup = 3"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M190 0H185V189H190V225H185V297V306V311H229V306H263V311H269V306V297V255H569H575H581V211H575V148H581V128H575V79H581V0H575H569H206H190Z"
                  fill="#1F479A"
                />
                <path
                  class="block4"
                  @click="popup = 4"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0 148H182V285V306V311H141V306H85V311H0V306V285V148Z"
                  fill="#1F479A"
                />
                <path
                  class="block1"
                  @click="popup = 1"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M269 315H0V515V517V521H13V517H75V521H112V517H260V521H269V517V515V315Z"
                  fill="#1F479A"
                />
                <path
                  class="block2"
                  @click="popup = 2"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M503 259H272V509V517V521H345V517H481H503H554V521H581V515V474H577V322H581V259H575V263H503V259Z"
                  fill="#1F479A"
                />
              </g>

              <path
                d="M134.122 433H139.252V393.31L125.158 398.764V403.678L134.122 400.222V433Z"
                fill="white"
              />
              <path
                d="M412.296 398.892L412.35 399H438.27V394.356H422.61L422.556 394.248L429.36 386.094C433.95 380.586 436.866 376.104 436.866 370.758C436.866 363.252 431.196 359.31 424.284 359.31C420.504 359.31 417.264 360.498 415.266 361.794V366.978C418.02 364.98 421.26 364.062 424.014 364.062C428.55 364.062 431.736 366.492 431.736 371.028C431.736 374.7 429.63 378.102 425.202 383.394L412.296 398.892Z"
                fill="white"
              />
              <path
                d="M98.812 208.904H94.114L73.972 238.442L74.026 238.55H93.736V248H98.812V238.55H105.832V234.014H98.812V208.904ZM88.876 224.078C90.496 221.702 92.224 219.164 93.736 216.734L93.844 216.788C93.79 219.164 93.736 222.08 93.736 224.78V234.014H82.234L82.18 233.906L88.876 224.078Z"
                fill="white"
              />
              <path
                d="M79.024 85.002C81.508 86.568 85.018 87.594 88.852 87.594C97.06 87.594 102.73 82.95 102.73 75.714C102.73 66.804 94.252 63.834 86.152 63.834L86.962 52.548H101.272L101.65 47.904H82.21L80.644 68.64C82.048 68.424 83.614 68.316 85.018 68.316C90.472 68.316 97.6 69.882 97.6 75.93C97.6 80.25 93.928 82.842 88.852 82.842C85.612 82.842 82.318 81.816 79.402 79.656L79.024 85.002Z"
                fill="white"
              />
              <path
                d="M370.862 133.976C373.13 135.974 377.072 137.594 381.608 137.594C389.168 137.594 394.676 133.112 394.676 126.308C394.676 121.988 392.462 118.1 387.602 117.074V116.966C391.436 115.832 393.866 112.484 393.866 108.11C393.866 101.63 388.628 97.31 381.5 97.31C378.314 97.31 375.344 98.174 373.184 99.47V104.708C375.398 103.142 378.314 102.062 381.23 102.062C385.658 102.062 388.736 104.546 388.736 108.596C388.736 112.43 385.982 115.13 381.068 115.13H377.558V119.666H381.23C386.792 119.666 389.546 122.366 389.546 126.2C389.546 130.358 386.198 132.842 381.554 132.842C377.882 132.842 374.102 131.276 370.862 128.09V133.976Z"
                fill="white"
              />
            </svg>

            <div v-if="popup == 1" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Polymer Printing</h3>
                  <div class="line2"></div>
                  <p>
                    The polymer printing room is home to a variety of additive
                    manufacturing technologies. These polymer printers are
                    utilized to create concept models, functional prototypes,
                    and end use parts out of plastic.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 2" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Metal Printing</h3>
                  <div class="line2"></div>
                  <p>
                    The metal printing space is where our titanium printer
                    resides. This machine uses medical grade titanium powder to
                    build parts for a range of end use products, including
                    unique medical devices and patient specific implants.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 3" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Post Processing</h3>
                  <div class="line2"></div>
                  <p>
                    The post processing room features equipment and tools used
                    to transform raw printed parts into their final form.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 4" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Office/Inspection</h3>
                  <div class="line2"></div>
                  <p>
                    The office and inspection area has CAD workstations for
                    design, model preparation, and file transfer. Inspection
                    equipment ensures that parts meet design specifications and
                    quality requirements.
                  </p>
                </div>
              </div>
            </div>

            <div v-if="popup == 5" class="popup">
              <div class="offclick" @click="popup = false"></div>
              <div class="room">
                <div class="info">
                  <h3>Storage</h3>
                  <div class="line2"></div>
                  <p>
                    The storage room contains all raw materials and consumables
                    used in the additive manufacturing process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition>
          <div class="process" v-if="current === 'process'">
            <h3>Our Process</h3>
            <p>(Leave for now)</p>
          </div>
        </transition>

        <!-- <transition>
          <div class="link1" v-if="current === 'link1'">
            <h3>What is Additive Manufacturing?</h3>
            <p>
              Additive Manufacturing, or 3D Printing, is a process of
              fabricating three dimensional objects from a digital file. The
              creation process is achieved through laying down successive layers
              of material until the object is created. Each layer can be seen as
              an extremely thin horizontal cross section of the object Additive
              Manufacturing is the opposite of subtractive manufacturing; which
              is creation through removing material.
            </p>
          </div>
        </transition> -->

        <!-- <transition>
          <div class="link2" v-if="current === 'link2'">
            <h3>Common Types of 3D Printing</h3>
            <div class="sub-menu">
              <div class="printers">
                <div class="menu-item">
                  <p @click="popup = 1">
                    Fused deposition modeling (FDM)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
                <div class="menu-item">
                  <p @click="popup = 2">
                    Stereolithography (SLA)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
                <div class="menu-item">
                  <p @click="popup = 3">
                    Selective Laser Sintering (SLS)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
              </div>

              <div v-if="popup == 1" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Fused deposition modeling (FDM)</h3>
                    <div class="line2"></div>
                    <p>
                      Fused Deposition Modeling is one of the most popular
                      additive manufacturing technologies used today. Printers
                      that use this method create objects by extruding material
                      in very thin layers. Each layer can be seen as a cross
                      section of the object being printer. Click the video below
                      to learn more!
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/rkUILe3zv98"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9cLFAI1_fmU"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page Stratasys Fortus 400mc
                      Stratasys F370 Markforged Mark Two
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="popup == 2" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Fused deposition modeling (FDM)</h3>
                    <div class="line2"></div>
                    <p>
                      Stereolithography technology creates objects not by
                      material extrusion, but by vat polymerization. Objects are
                      built using a light source, typically a laser or
                      projector, to cure liquid resin into hard plastic. Click
                      the video below to learn more!
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/8a2xNaAkvLo"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/klW0nuefofY"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page Formlabs Form 3
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="popup == 3" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Selective Laser Sintering (SLS)</h3>
                    <div class="line2"></div>
                    <p>
                      Selective Laser Sintering is another a method of 3D
                      printing in the vat polymerization. Much like SLA, SLS
                      uses a laser to fuse material and build objects. The most
                      notable difference between the two is that SLS uses
                      powdered material instead of liquid resin.
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9E5MfBAV"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9cLFAI1_fmU"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page EOS M290 Titanium Printer
                      HP Jet Fusion 580 Color Printer (Multi Jet Fusion)
                    </p>
                  </div>
                </div>
              </div>
              <div class="printer-one">
                <h3>Fused deposition modeling (FDM)</h3>
              </div>
            </div>
          </div>
        </transition> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "overview",
      popup: null,
      popup: false
    };
  },
  methods: {
    toggleActive(event) {
      this.current = event.target.id;
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 90px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 0;
}
.video-modal h3 {
  font-size: 30px;
  margin-bottom: 10px;
  font-family: AzoSans;
  letter-spacing: auto;
}

h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  /* width: 500px; */
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 30px 0;
}
.column h3 {
  text-transform: uppercase;
}
.left {
  /* padding-left: 157px;
    flex: none;
    padding-top: 301px;
    width: 500px; */

  /* css for demo */
  /* padding-right: 120px; */
  padding-top: 235px;
  position: fixed;
  left: 200px;
}

.right {
  padding-top: 235px;
  padding-left: 600px;
  position: relative !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  width: 44%;
  /* height: 100vh !important; */
  justify-content: flex-start !important;
  overflow: hidden !important;
  overflow-x: auto !important;
}

.btn {
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 11;
  /* width: 100px;
  height: 50px;  */
}

.logo img {
  position: fixed;
  z-index: 11;
}

.menu {
  padding: 0;
  overflow: hidden !important;
}

.left-bg {
  width: 43%;
}

.card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.3);
  width: 48%;
  margin: 1%;
  height: 165px;
  /* border: 2px solid white; */
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 10px;
}

.card p {
  position: relative;
  font-size: 25px;
  padding-bottom: 10px;
  /* padding-top: 10px; */
  color: #ffffff;
  font-family: AzoSans;
  margin: 0;
  text-align: center;
}

.sub-menu {
  overflow: hidden !important;
  overflow-x: auto !important;
}

.info.row {
  display: flex;
}
.info img {
  width: 600px;
  margin-right: 5%;
  object-fit: cover;
}
</style>
